import { render, staticRenderFns } from "./OtherProductInfoTable.vue?vue&type=template&id=747d1e6d&scoped=true&"
import script from "./OtherProductInfoTable.vue?vue&type=script&lang=js&"
export * from "./OtherProductInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./OtherProductInfoTable.vue?vue&type=style&index=0&id=747d1e6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d1e6d",
  null
  
)

export default component.exports